import * as React from "react";
import type { SVGProps } from "react";
const SvgBubble = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#bubble_svg__a)">
      <path d="M3 22a.98.98 0 0 1-.74-.33c-.28-.3-.34-.75-.16-1.12l1.73-3.5A9.3 9.3 0 0 1 2 11.55C2 6.28 6.49 2 12 2s10 4.28 10 9.55-4.49 9.55-10 9.55c-1.46 0-2.87-.3-4.19-.88l-4.45 1.71c-.12.04-.24.07-.36.07m9-18c-4.41 0-8 3.39-8 7.55 0 1.74.61 3.37 1.77 4.73.26.3.31.73.14 1.09l-.88 1.78 2.46-.95c.26-.1.55-.09.8.04 1.16.57 2.41.87 3.71.87 4.41 0 8-3.39 8-7.55S16.41 4 12 4" />
      <path d="M9 13c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71s.11-.52.29-.71c.1-.09.2-.16.33-.21.36-.15.81-.07 1.09.21.19.19.29.45.29.71s-.1.52-.29.71c-.19.18-.45.29-.71.29M12 13c-.26 0-.52-.11-.71-.29l-.12-.15a.8.8 0 0 1-.09-.18.6.6 0 0 1-.06-.18c0-.07-.02-.13-.02-.2 0-.06 0-.13.02-.19.01-.07.03-.13.06-.19q.03-.09.09-.18l.12-.15c.37-.37 1.05-.37 1.42 0 .04.05.09.1.12.15q.06.09.09.18c.03.06.05.12.06.19.01.06.02.13.02.19 0 .07 0 .13-.02.2 0 .06-.03.12-.06.18q-.03.09-.09.18c-.03.05-.08.1-.12.15-.19.18-.45.29-.71.29M15 13c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71s.11-.52.29-.71c.37-.37 1.05-.37 1.42 0 .19.19.29.45.29.71s-.1.52-.29.71c-.19.18-.45.29-.71.29" />
    </g>
    <defs>
      <clipPath id="bubble_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBubble;
